import {accountingConstants} from '../constants';

const accountingState = {
  accountingFields: [],
  companySettings: {},
  // Whether the settings request has come back at all — success or failure. The accounting nav
  // waits on this so it never paints NetSuite branding at a Manual ERP company (H1MVP-4791).
  companySettingsResolved: false,
  costCenters: [],
  customSegments: [],
  expenseCategories: [],
  listItems: [],
  locations: [],
  numberingFlows: [],
  taxCodes: [],
  vendorExpenseAccounts: [],
  creditAccounts: [],
};

const accountingReducer = (state = accountingState, action) => {
  const {type} = action;
  switch (type) {
    case accountingConstants.GET_ACCOUNTING_FIELDS:
      return {
        ...state,
        accountingFields: Array.isArray(action.data) ? action.data : []
      }
    case accountingConstants.GET_COMPANY_SETTINGS:
      return {
        ...state,
        companySettings: action.data || {},
        companySettingsResolved: true
      }
    case accountingConstants.GET_COST_CENTERS:
      return {
        ...state,
        costCenters: action.data || []
      }
    case accountingConstants.GET_CUSTOM_SEGMENTS:
      return {
        ...state,
        customSegments: Array.isArray(action.data) ? action.data : []
      }
    case accountingConstants.GET_EXPENSE_CATEGORIES:
      return {
        ...state,
        expenseCategories: action.data || []
      }
    case accountingConstants.GET_LIST_ITEMS:
      return {
        ...state,
        listItems: action.data || []
      }
    case accountingConstants.GET_LOCATIONS:
      return {
        ...state,
        locations: action.data || []
      }
    case accountingConstants.GET_NUMBERING_FLOWS:
      return {
        ...state,
        numberingFlows: action.data || []
      }
    case accountingConstants.GET_TAX_CODES:
      return {
        ...state,
        taxCodes: action.data || []
      }
    case accountingConstants.GET_VENDOR_EXPENSE_ACCOUNTS:
      return {
        ...state,
        vendorExpenseAccounts: action.data || []
      }
    case accountingConstants.GET_CREDIT_ACCOUNTS:
      return {
        ...state,
        creditAccounts: action.data || []
      }
    // Every other slice that holds company-scoped data is cleared when the company changes; this one
    // was not, and it holds the ERP mode. So switching from a Manual ERP company to a NetSuite one
    // left `companySettings.is_export_mode` true AND `companySettingsResolved` already true — so the
    // nav never waited, and the NetSuite company rendered the Manual UI: Register instead of Sync,
    // posting to /register/* on a company that has a real NetSuite to sync to.
    case accountingConstants.CLEAR_ACCOUNTING_DATA:
      return {...accountingState};
    default:
      return state;
  }
};

export default accountingReducer;
